import { Outlet } from 'react-router-dom'

const CommonLayout = () => {
  return <Outlet />
}

export default CommonLayout
